export const defaultEditSegmentSettings = () => ({
    segmentId: '',
    segmentActionType: 'addToSegment'
});

// We have two action type for EditSegment
// action_type='add_to_segment'
// action_type='remove_from_segment'
